import { buildSimpleFiltersComponent } from '../category/filtersRenderer'
import './sp.branches'

$(document).ready(() => {
  const branches = {
    section: '#branches',
    citySelect: '#branches #chooseCity',
    allCities: messageResource['branch.facet.allCities'],
    selectedFilters: [],
    loader: isMobile ? '#loader' : null,
    location: null,
    maxLocationResults: isMobile ? 10 : null,
    openedFacets: [],
    geoLocationIsAllowed: false,

    initCustomSelect: () => {
      const cSelect = $(
        this.section +
          (isMobile ? ' .branch-custom-select' : '.branches-custom-select')
      )
      cSelect.fancySelect({ includeBlank: true }).on('change.fs', () => {
        $(this).trigger('change.$')
      })
      cSelect.trigger(isMobile ? 'update' : 'update.fs')
    },
    initMetaData: () => {
      if (isMobile) {
        branches.getGeoLocation((location) => {
          branches.location = location
          SP.branches.getMetadata(
            branches.location,
            (data) => {
              data.cityList.unshift(branches.allCities)
              branches.initCitySelect(data.cityList)
              branches.filtersData = data.facets
              branches.buildFilters()
              branches.updateResults(data)
              $('#openFilters').click(branches.openFilters)
              $('#closeFilters,.close-filters').click(branches.closeFilters)
            },
            branches.maxLocationResults
          )
        })
      } else {
        const location = null
        SP.branches.getMetadata(location, (data) => {
          data.cityList.unshift(branches.allCities)
          branches.initCitySelect(data.cityList)
          branches.filtersData = data.facets
          branches.buildFilters()
          branches.updateResults(data)
          branches.changeButtonsLabel()
        })
      }
    },
    getGeoLocation: (callback) => {
      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      }

      const success = (pos) => {
        const crd = pos.coords

        callback(crd)
      }

      const error = (err) => {
        branches.geoLocationIsAllowed = false
        // alert('ERROR(' + err.code + '): ' + err.message);
        console.warn('ERROR(' + err.code + '): ' + err.message)

        callback(null)
      }

      if (navigator.geolocation) {
        branches.geoLocationIsAllowed = true
        navigator.geolocation.getCurrentPosition(success, error, options)
      } else {
        //alert('no geo');
        console.warn('ERROR')

        callback(null)
      }
    },
    initCitySelect: (cityArray) => {
      //=====set geolocation option
      isMobile &&
        cityArray.splice(0, 0, messageResource['branches.currentLocation'])
      //============================
      const $cities = $(branches.citySelect)

      $cities
        .autocomplete({
          source: cityArray,
          autoFocus: isMobile && true,
          select: (event, ui) => {
            $cities.val(ui.item.value)
            branches.selectCity()
            $(this).blur()
          },
          open: (event, ui) => {
            if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
              $('.ui-autocomplete').off('menufocus hover mouseover')
            }
          },
          minLength: 0,
        })
        .blur((e) => {
          if (!$(e.target).data('ui-autocomplete').selectedItem) {
            $cities.val('')
          }
        })
        .focus(() => {
          $(this).autocomplete('search', '')
        })
    },

    buildFilters: () => {
      const filtersData = branches.filtersData
      const preSelectedFilters = SP.branches.query.filters
      $.each(preSelectedFilters, (index, value) => {
        filtersData.map((filterParent) => {
          if (filterParent.code == value.parentCode) {
            filterParent.values.map((filter) => {
              if (filter.code == value.code) {
                filter.selected = true
                const selectedFilter = {
                  name: filter.name,
                  code: value.code,
                  parentCode: value.parentCode,
                }
                branches.selectedFilters.push(selectedFilter)
              }
            })
          }
        })
      })

      const $filters = $(isMobile ? '#filtersWrap' : '#filters')
      $.each(filtersData, (index, value) => {
        let resultHtml = isMobile ? null : '<div class="col-xs-3">'
        value.values.unshift({
          code: -1,
          name:
            value.code == 'service'
              ? messageResource['branch.facet.allServices']
              : value.name,
          selected: false,
        })
        if (isMobile) {
          $filters.append(buildSimpleFiltersComponent(value, false, 4))
        } else {
          resultHtml = resultHtml.concat(
            branches.buildSimpleFiltersComponent(value)
          )

          resultHtml = resultHtml.concat('</div>')

          $filters.append(resultHtml)
        }
      })
      if (isMobile) {
        $('#filters input[type=checkbox]').change(
          branches.changeCheckbox.bind(this)
        )
        //branches.initCheckedFilters()
        branches.initShowMoreFacets()
      } else {
        $('#filters input[type=checkbox]').change(
          branches.changeCheckbox.bind(this)
        )
      }
      branches.toggleShowMore()
      branches.initfilters()
      $('#filtersBackdrop').click((e) => {
        branches.closeFilters(e)
      })

      // $('#filters input[type=checkbox]').change(branches.changeCheckbox)
      branches.initCheckedFilters()
    },

    initShowMoreFacets: () => {
      $('#filters .toggle-more').each((_, el) => {
        const $this = $(el)
        const filterComp = $this.closest('.filters-component')
        const filterCompsCode = filterComp.attr('data-id')
        let isPreOpened = []
        if (branches.openedFacets.length != 0) {
          isPreOpened = $.grep(
            branches.openedFacets,
            (code) => code == filterCompsCode
          )
        }
        if (isPreOpened.length) {
          $this.addClass('open')
          filterComp.find('.show-more').removeClass('hide')
        }
        $this.click((e) => {
          e.preventDefault()

          if (!$this.hasClass('open')) {
            // Blur the "More Items" buttons to solve an issue in Chromium
            $this.blur()
            $this.addClass('open')
            filterComp.find('.show-more').removeClass('hide')
            branches.openedFacets.push(filterCompsCode)
          } else {
            $this.removeClass('open')
            filterComp.find('.show-more').addClass('hide')
            const index = branches.openedFacets.indexOf(filterCompsCode)
            if (index > -1) {
              branches.openedFacets.splice(index, 1)
            }
          }
        })
      })
    },

    initfilters: () => {
      if (isMobile) {
        // $('#filtersWrap .filters-component .open-filter-list').click(
        //   branches.openFilterList
        // )
        // $(
        //   '#filtersWrap .filters-component .select-filters-wrap .close-filter-wrap'
        // ).click(branches.closeFilterList)
      } else {
        const filterWrap = $('#filters .filters-component')

        const filtersBox = filterWrap.find('.filter-component-title')
        const filterItems = filterWrap.find('.filter-items')
        filtersBox.attr({ role: 'listbox', tabindex: 0 })

        filtersBox.click((e) => {
          openDropdown(e)
        })
        filtersBox.on('keydown', openDropdown)

        filtersBox.each((i, filterBox) => {
          const $this = $(filterBox)
          $this.attr('data-label', $this.html())
        })

        $(window).click(() => {
          filterWrap.removeClass('open')
        })
        filterItems.click((e) => {
          e.stopPropagation()
        })
        filterItems.find('>label').click(() => {
          filterWrap.removeClass('open')
        })
        filterItems.find('>label').on('keydown', () => {})

        const openDropdown = (e) => {
          e.stopPropagation()
          if (e.keyCode && e.keyCode != 13) {
            return
          }

          $(e.target).closest('.filters-component').toggleClass('open')
          if ($(e.target).closest('.filters-component').hasClass('open')) {
            $(e.target).next().find('label[tabindex=0]').first().focus()
          }
        }

        filterItems
          .find('label[tabindex=0]')
          .focus((e) => {
            $(e.target).closest('li').addClass('hover')
          })
          .blur((e) => {
            $(e.target).closest('li').removeClass('hover')
          })
      }
    },

    initCheckedFilters: () => {
      $('#filters input[type=checkbox]:checked').each(branches.changeCheckbox)
    },

    openFilterList: () => {
      $(this).next().addClass('open')
    },

    closeFilterList: (e) => {
      e.preventDefault()
      $(this).closest('.select-filters-wrap').removeClass('open')
    },

    openFilters: () => {
      $('#filters').addClass('open')
      $('body').addClass('noscroll')
      $('#filtersBackdrop').addClass('open')
    },

    closeFilters: (e) => {
      e.preventDefault()
      $('#filters').removeClass('open')
      $('#filtersBackdrop').removeClass('open')
      $('body').removeClass('noscroll')
    },

    changeCheckbox: (e) => {
      const element = e.currentTarget
      const $this = $(element)

      const filter = {
        name: $this.attr('data-name'),
        code: $this.attr('data-id'),
        parentCode: $this.attr('data-parent-id'),
      }

      const isMulti = $this.attr('data-multi')

      if (filter.code == -1) {
        $(this).prop('checked', true)
        $this
          .closest('.filter-items')
          .find('.check-item input')
          .each(function (idx) {
            if (idx === 0) return

            $(this).prop('checked', false)
            branches.removeFromTags($(this).attr('data-id'))
          })
      } else if ($this.prop('checked')) {
        if (isMulti == 'false') {
          // to remove?
          $this
            .closest('.filter-items')
            .find('.check-item input:checked:not(#' + $this.attr('id') + ')')
            .each(() => {
              $(this).prop('checked', false)
              branches.removeFromTags($(this).attr('data-id'))
            })
        }

        branches.selectedFilters.push(filter)
        $this
          .closest('.filter-items')
          .find('label:first-child .check-item input')
          .prop('checked', false)
      } else {
        branches.removeFromTags(filter.code)

        const hasOtherFilters = branches.selectedFilters.filter(
          (currFilter) => {
            return currFilter.parentCode === filter.parentCode
          }
        ).length

        if (!hasOtherFilters) {
          $this
            .closest('.filter-items')
            .find('label:first-child .check-item input')
            .prop('checked', true)
        }
      }
      if (e.preventDefault) {
        //the function comes from an element and not on init
        branches.updateResults()
      }

      branches.changeButtonsLabel()
    },

    removeFromTags: (id) => {
      branches.selectedFilters = branches.selectedFilters.filter((obj) => {
        return obj.code !== id
      })
    },

    updateResults: (data) => {
      const counter = $('#resultsCounter')
      const container = $('#results-boxes')
      const $citySelect = $(branches.citySelect)
      const citySummery = $('#results-city')

      let city = $citySelect.val()
      if (city == branches.allCities) {
        city = ''
      }
      container.addClass('fade')

      if (data) {
        if (isMobile) {
          branches.buildResults(
            data.storeList,
            data.pagination.totalNumberOfResults,
            data.city,
            data.location,
            data.pagination.numberOfPages - 1 > data.pagination.currentPage,
            container,
            counter,
            $citySelect,
            null,
            null
          )
        } else {
          branches.buildResults(
            data.storeList,
            data.pagination.totalNumberOfResults,
            data.city,
            null,
            data.pagination.numberOfPages - 1 > data.pagination.currentPage,
            container,
            counter,
            $citySelect,
            data,
            citySummery
          )
        }
      } else {
        if (isMobile) {
          let applyDistanceLimit = false
          if (city == messageResource['branches.currentLocation']) {
            applyDistanceLimit = true

            if (!branches.location) {
              branches.getGeoLocation((location) => {
                SP.branches.filterResults(
                  branches.selectedFilters,
                  '',
                  location,
                  branches.maxLocationResults,
                  branches.buildResults,
                  applyDistanceLimit
                )
              })
            }
          }

          SP.branches.filterResults(
            branches.selectedFilters,
            city === messageResource['branches.currentLocation'] ||
              city === branches.allCities
              ? ''
              : city,
            branches.location,
            branches.maxLocationResults,
            branches.buildResults,
            applyDistanceLimit
          )
        } else {
          SP.branches.filterResults(
            branches.selectedFilters,
            city,
            location,
            null,
            branches.buildResults,
            null
          )
        }
      }
    },
    buildResults: (
      result,
      resultsCount,
      resultsCity,
      location,
      isThereMore,
      container,
      counter,
      $citySelect,
      data,
      citySummery
    ) => {
      let html = ''
      let res = result.storeList || result
      res.map((item) => {
        const compiledTemplate = Handlebars.getSharedTemplate('storeRow')
        if (branches.geoLocationIsAllowed) {
          if (item.distance) {
            item.distance = Number(item.distance).toFixed(2)
          }
        } else {
          item.distance = null
        }

        const resultHtml = compiledTemplate({ branch: item })
        html = html.concat(resultHtml)
      })
      if (!isMobile) {
        let indexboxes = ''
        const compiledTemplate = Handlebars.getTemplate('index-box', 'branches')
        const resultIndexBoxHtml = compiledTemplate({
          branchFilterData: data || result,
        })

        indexboxes = indexboxes.concat(resultIndexBoxHtml)
      }

      $(branches.loader).fadeOut()
      container.html(html)

      container.removeClass('fade')
      counter.html(resultsCount)
      $('.btn-more').toggleClass('hide', !isThereMore)
      if (!isMobile) {
        $citySelect.val(resultsCity).trigger('update')
        if (resultsCity) {
          citySummery.html(resultsCity)
        } else {
          citySummery.html(citySummery.attr('data-empty'))
        }
      }
      if (location) {
        $citySelect
          // .val(messageResource['branches.currentLocation'])
          .trigger('update')
      } else if (isMobile) {
        $citySelect.val('').trigger('update')
      }

      if (resultsCount) {
        $('.results-summery').removeClass('hide')
        container.removeClass('hide')
        $('.empty-results').addClass('hide')
      } else {
        $('.results-summery').addClass('hide')
        container.addClass('hide')
        $('.empty-results').removeClass('hide')
      }
    },
    toggleShowMore: () => {
      $('.btn-more').click((e) => {
        const $this = $(e.currentTarget)
        // Blur the "More Items" buttons to solve an issue in Chromium
        $this.blur()

        SP.branches.getMoreResults((results, isThereMore) => {
          let html = ''
          results.map((item) => {
            const compiledTemplate = Handlebars.getSharedTemplate('storeRow')
            if (branches.geoLocationIsAllowed) {
              if (item.distance) {
                item.distance = Number(item.distance).toFixed(2)
              }
            } else {
              item.distance = null
            }
            const resultHtml = compiledTemplate({ branch: item })
            html = html.concat(resultHtml)
          })
          $('#results-boxes').append(html)
          $this.toggleClass('hide', !isThereMore)
        })
      })
    },
    selectCity: (e) => {
      branches.updateResults()
    },
    changeButtonsLabel: () => {
      if (isMobile) {
        const allButtons = $('.open-filter-list')
        allButtons.each(branches.resetlabel)
      } else {
        const filterWrap = $('#filters .filters-component')
        const allButtons = filterWrap.find('.filter-component-title')
        allButtons.each(branches.resetlabel)
      }
      $.each(branches.selectedFilters, (index, filter) => {
        if (filter.range) {
          return
        }
        const button = $(
          'input[id=filter_' + filter.parentCode + '_' + filter.code + ']'
        )
          .closest(isMobile ? '.select-filters-wrap' : '.filter-items')

          .prev()
        if (isMobile) {
          const buttonSpan = button.find('span')
          if (buttonSpan.html() == button.attr('data-label')) {
            buttonSpan.html(filter.name)
          } else {
            const text = buttonSpan.html() + ',' + filter.name
            buttonSpan.html(text)
          }
        } else {
          if (button.html() == button.attr('data-label')) {
            button.html(filter.name)
          } else {
            const text = button.html() + ', ' + filter.name
            button.html(text)
          }
        }
      })
    },
    resetlabel: (i, e) => {
      const $this = $(e)

      const label = $this.attr('data-label')
      if (isMobile) {
        $this.find('span').html(label)
      } else {
        $this.html(label)
      }
    },
    buildSimpleFiltersComponent: (filterObj) => {
      let html = ''
      const compiledTemplate = Handlebars.getTemplate(
        isMobile ? 'branchFilterComponent' : 'filterComponent',
        isMobile ? 'branches' : 'search-filters'
      )
      const resultHtml = compiledTemplate({
        item: filterObj,
        isSubFilter: null,
      })
      html = html.concat(resultHtml)
      return html
    },
    goBack: (e) => {
      SP.branches.goBack(e.state, branches.updateResults)
    },

    init: () => {
      if (!$(branches.section).length) {
        return
      }

      window.addEventListener('popstate', branches.goBack)
      branches.initMetaData()
    },
  }

  setTimeout(() => {
    if (!$(branches.section).length) {
      return
    }
    branches.init()
  })
})
